var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 12.7122C12.0551 12.0532 10.906 11.6667 9.66659 11.6667C6.66999 11.6667 4.20113 13.9262 3.87082 16.8344C3.84744 17.0402 3.83575 17.1432 3.87684 17.2426C3.91047 17.3238 3.98325 17.4053 4.06025 17.4479C4.15435 17.5 4.26955 17.5 4.49993 17.5H8.78721M12.1666 16.0714L13.6666 17.5L17.1666 14.1667M12.9999 5.83333C12.9999 7.67428 11.5076 9.16667 9.66659 9.16667C7.82565 9.16667 6.33327 7.67428 6.33327 5.83333C6.33327 3.99238 7.82565 2.5 9.66659 2.5C11.5076 2.5 12.9999 3.99238 12.9999 5.83333Z",
    stroke: "#50515C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactIcon3);
export default __webpack_public_path__ + "static/media/fact-icon3.207925c32d2c73dd04607ed2a25407e9.svg";
export { ForwardRef as ReactComponent };